// todo: Each route with component should be wrapped in an class
import { lazy } from 'react';

import {
  CARDS_PATH,
  COMICS_PATH,
  DIAMOND_DUNGEON,
  DIAMONDS_PATH,
  HERO_PATH,
  JOBS_PATH,
  NEWS_PATH,
  PACKS_PATH,
  RADAR_PATH,
  SEASON_TICKET_PATH,
} from '~/routes/paths';
import InventoryIcon from '~/views/CardListView/InventoryIcon';
import HeroTabIcon from '~/views/HeroView/HeroTabIcon';
import RadarIcon from '~/views/RadarView/RadarIcon';

import { ReactComponent as DiamondIcon } from '~/assets/images/iconsLibrary/diamond.svg';
import { ReactComponent as HomeIcon } from '~/assets/images/iconsLibrary/home.svg';
import { ReactComponent as JobzIcon } from '~/assets/images/iconsLibrary/jobz.svg';

const CampaignsView = lazy(() => import('~/views/CampaignsView'));
const RadarView = lazy(() => import('~/views/RadarView'));
const CardListView = lazy(() => import('~/views/CardListView'));
const ComicListView = lazy(() => import('~/views/ComicListView'));
const HomeView = lazy(() => import('~/views/HomeView'));
const HeroView = lazy(() => import('~/views/HeroView'));
const LootListView = lazy(() => import('~/views/LootListView'));
const NewsView = lazy(() => import('~/views/NewsView'));
const NotFoundView = lazy(() => import('~/views/NotFoundView'));
const DiamondDungeonView = lazy(() => import('~/views/DiamondDungeonView'));
const JobsView = lazy(() => import('~/views/JobsView'));
const UserRankingList = lazy(() => import('~/views/UserRankingList'));
const CookiesTermsView = lazy(() => import('~/views/CookiesTermsView'));
const SubscriptionContainer = lazy(() =>
  import('~/views/SubscriptionContainer'),
);

/**
 *
 * @param {Array<string>} disabledPaths
 */
export const getMainViewRoutes = (disabledPaths) =>
  [
    {
      path: PACKS_PATH,
      tab: {
        translation: 'TabBar_packs',
        icon: HomeIcon,
      },
      panel: {
        component: HomeView,
      },
      exact: true,
    },
    {
      path: DIAMONDS_PATH,
      tab: {
        translation: 'TabBar_quests',
        icon: DiamondIcon,
      },
      panel: {
        component: LootListView,
      },
    },
    {
      path: HERO_PATH,
      tab: { translation: 'TabBar_hero', icon: HeroTabIcon },
      panel: { component: HeroView },
    },
    {
      path: CARDS_PATH,
      tab: {
        translation: 'TabBar_cards',
        icon: InventoryIcon,
      },
      panel: {
        component: CardListView,
      },
    },
    {
      path: RADAR_PATH,
      tab: {
        translation: 'TabBar_chats',
        icon: RadarIcon,
      },
      panel: {
        component: RadarView,
      },
    },
    {
      path: JOBS_PATH,
      tab: {
        translation: 'TabBar_jobz',
        icon: JobzIcon,
      },
      panel: {
        component: JobsView,
      },
    },
    {
      path: COMICS_PATH,
      panel: {
        component: ComicListView,
      },
    },
    {
      path: NEWS_PATH,
      panel: {
        component: NewsView,
      },
    },
    {
      path: '/cookie-terms',
      panel: {
        component: CookiesTermsView,
      },
    },
    {
      path: ['/merchant/:urlAliasOrId', '/market/:urlAliasOrId'],
      panel: {
        component: CampaignsView,
      },
    },
    {
      panel: { component: SubscriptionContainer },
      path: SEASON_TICKET_PATH,
      exact: true,
    },
  ]
    .filter(({ path }) =>
      Array.isArray(path)
        ? !path.some((p) => disabledPaths.includes(p))
        : !disabledPaths.includes(path),
    )
    .flatMap(
      (route) =>
        route.path.map?.((path) => ({
          ...route,
          path,
        })) || route,
    );

export const getMainViewTabs = (disabledPaths) =>
  getMainViewRoutes(disabledPaths).filter(({ tab }) => tab);

export const mainViewTabPaths = getMainViewTabs([]).map(({ path }) => path);

export const routesInContainer = [
  {
    component: UserRankingList,
    path: ['/lootboysfinest', '/lootboysfinest/t'],
  },
  {
    component: DiamondDungeonView,
    path: DIAMOND_DUNGEON,
    ensureLoggedIn: true,
  },
  {
    component: NotFoundView,
    path: '/404',
  },
];
